import { ApiPropertyOptional, PartialType, PickType } from '@nestjs/swagger';
import { RepairPaymentDto } from './repair-payment.dto';
import { RepairPaymentCreatableInterface } from '../interfaces/repair-payment-creatable.interface';
import { IsOptional, IsUUID } from 'class-validator';

export class RepairPaymentCreateDto
  extends PartialType(
    PickType(RepairPaymentDto, [
      'jobRepairId',
      'repairFormulaId',
      'contractorId',
      'estimatedHours',
      'fixedAmount',
      'extraHours',
      'repairPaymentDate',
    ]),
  )
  implements RepairPaymentCreatableInterface
{
  @ApiPropertyOptional({
    type: 'string',
    nullable: true,
    format: 'uuid',
    title: 'Region Time Window ID',
  })
  @IsUUID()
  @IsOptional()
  regionTimeWindowId?: string;
}
